import { render, staticRenderFns } from "./addOrEditMutilGoods.vue?vue&type=template&id=c0bc06e2&scoped=true&"
import script from "./addOrEditMutilGoods.vue?vue&type=script&lang=js&"
export * from "./addOrEditMutilGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc06e2",
  null
  
)

export default component.exports